import { Collapse, Group, Paper, Text, UnstyledButton } from '@mantine/core';
import { useState } from 'react';

import type { ArenaRun, ReportError } from '../hooks/useModelArena';
import { runMoment } from '../runGrouping';
import { countLabel, durationLabel, timeLabel } from '../runLabels';

import { ExpandChevron } from './ExpandChevron';
import { RunDetails } from './RunDetails';
import { RunHeadline } from './RunHeadline';
import { StatusBadge } from './StatusBadge';

export function RunRow({
  run,
  rankMetric,
  reportError,
}: {
  run: ArenaRun;
  rankMetric: string | null;
  reportError: ReportError;
}) {
  const [expanded, setExpanded] = useState(false);
  const duration = durationLabel(run);

  return (
    <Paper withBorder radius="sm">
      <UnstyledButton
        w="100%"
        p="xs"
        onClick={() => setExpanded(open => !open)}
        aria-expanded={expanded}
      >
        <Group gap="sm" wrap="nowrap">
          <ExpandChevron expanded={expanded} size={14} />
          <Text size="sm" fw={500} w={44} style={{ flexShrink: 0 }}>
            {timeLabel(runMoment(run))}
          </Text>
          <StatusBadge status={run.status} w={92} />

          <RunHeadline run={run} rankMetric={rankMetric} />

          <Text size="xs" c="dimmed" ml="auto" style={{ flexShrink: 0 }}>
            {countLabel(run.candidates.length, 'candidate')}
            {duration && ` · ${duration}`}
          </Text>
        </Group>
      </UnstyledButton>

      <Collapse expanded={expanded}>
        <RunDetails run={run} rankMetric={rankMetric} reportError={reportError} />
      </Collapse>
    </Paper>
  );
}
